exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PrevNext{padding:1em}.PrevNext--compact{padding:.35em 0;text-align:right;position:relative;z-index:1}@media screen and (max-width:625px){.PrevNext--compact{display:none}}.PrevNext--overlay{width:100%;padding:0;overflow:hidden;margin:0 auto;position:relative;z-index:10}@media screen and (max-width:625px){.PrevNext--overlay{font-size:1.2em}}.PrevNext--compact .PrevNext__button{background:none;border:none;font-family:Georgia,Times New Roman,serif;color:#979797;position:absolute}.PrevNext--compact .PrevNext__button--next{right:0}.PrevNext--compact .PrevNext__button--prev{right:1.25em}.PrevNext__button{background:#fff;border:1px solid #009096;border-radius:3px;color:#009096;text-transform:uppercase;font-family:Lato,Helvetica,sans-serif;font-weight:700;font-size:.75em}.PrevNext__button--next{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/PrevNext.scss
// module id = 143
// module chunks = 0